<template>
  <div class="update_pwd_ ">
    <div class="container_">
      <p style="text-align: center;font-size: 20px;">
        {{ $t("personalInfo[39]") || "修改登录密码" }}
      </p>
      <div class="login_right_" :class="{ long: $i18n.locale != 'zh-cn' }">
        <div>
          <span>{{ $t("personalInfo[40]") || "原密码" }}</span>
          <a-input
            v-model="oldPwd"
            style="width: 316px;height: 50px;margin-bottom: 19px;margin-left: 10px;"
            :placeholder="$t('personalInfo[40]') || '原始密码'"
            type="password"
          ></a-input>
        </div>
        <div>
          <span>{{ $t("personalInfo[41]") || "新密码" }}</span>
          <a-input
            v-model="newPwd1"
            style="width: 316px;height: 50px;margin-bottom: 19px;margin-left: 10px;"
            :placeholder="
              $t('personalInfo[42]') || '8-20位字母、数字组合，区分大小写'
            "
            type="password"
          ></a-input>
        </div>
        <div>
          <span>{{ $t("personalInfo[43]") || "确认密码" }}</span>
          <a-input
            v-model="newPwd2"
            style="width: 316px;height: 50px;margin-bottom: 30px;margin-left: 10px;"
            :placeholder="$t('personalInfo[44]') || '再次输入密码'"
            type="password"
          ></a-input>
        </div>
        <div class="flex_btnl" :class="{ long: $i18n.locale != 'zh-cn' }">
          <div class="flex_">
            <a-button
              type="primary"
              style="width: 160px;height: 40px;"
              @click="updatePwd"
              >{{ $t("personalInfo[1]") || "修改" }}</a-button
            >
            <a-button
              style="width: 160px;height: 40px;margin-left:30px;"
              @click="cancel"
              >{{ $t("InsuranceInfo[15]") || "取消" }}</a-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
import { setLogined, setLang } from "@/utils/authorized";
import moment from "moment";
import { setTimeout } from "timers";

export default {
  data() {
    return {
      errorMsg: "",
      hasError: false,
      mobileForm: this.$form.createForm(this),
      activeTab: 0,
      imgCodeUri: "/api/login/defaultKaptcha?rand=" + Math.random(),
      imgCodeUri: "",
      submitDisabled: false,
      loginType: "account", // account 账号  mobile 手机号
      flag: true,
      cardNo: "",
      name: "",
      idNo: "",
      oldPwd: "",
      newPwd1: "",
      newPwd2: ""
    };
  },
  mounted() {},
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  methods: {
    cancel() {
      this.$router.go(-1);
    },
    updatePwd() {
      if (this.oldPwd == "") {
        this.$message.error(this.$t("personalInfo[45]"));
        return false;
      }
      if (this.newPwd1 == "") {
        this.$message.error(this.$t("personalInfo[46]"));
        return false;
      }
      if (this.newPwd2 == "") {
        this.$message.error(this.$t("personalInfo[47]"));
        return false;
      }
      let reg = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/);
      if (this.newPwd1.length < 8 || !reg.test(this.newPwd1)) {
        if (this.$i18n.locale == "zh-cn") {
          this.$message.error("密码最少8位，且由数字和字母组成，请重新输入！");
        } else {
          this.$message.error(
            "The password is at least 8 characters and consists of numbers and letters, please re-enter！"
          );
        }
        return false;
      }
      if (this.newPwd2.length < 8 || !reg.test(this.newPwd2)) {
        if (this.$i18n.locale == "zh-cn") {
          this.$message.error("密码最少8位，且由数字和字母组成，请重新输入！");
        } else {
          this.$message.error(
            "The password is at least 8 characters and consists of numbers and letters, please re-enter！"
          );
        }
        return false;
      }
      let param = {
        oldPwd: this.oldPwd,
        newPwd1: this.newPwd1,
        newPwd2: this.newPwd2
      };
      api.updatePwd(param).then(res => {
        console.log(res);
        this.$message.success(res.data.msg);
        setTimeout(() => {
          this.$router.push({
            name: "login"
          });
        }, 1000);
      });
    },
    forgetPwd() {
      this.$router.push("/Home/ForgetPwd");
    },
    rememberPwd(e) {
      console.log(`checked = ${e.target.checked}`);
    },
    saveLang(langNum) {
      const lang = langNum == "01" ? "zh-cn" : "en-us";
      setLang(lang);
      moment.locale(lang);
      this.$i18n.locale = lang;
    },
    changeLanguage() {
      let lang = "zh-cn";
      let langNum = "01";
      if (this.$i18n.locale == "en-us") {
        this.$i18n.locale = "zh-cn";
      } else {
        this.$i18n.locale = "en-us";
        lang = "en-us";
        langNum = "02";
      }
      setLang(lang);
      moment.locale(lang);
      api
        .changeLang({
          language: langNum
        })
        .then(res => res.data);
    }
  }
};
</script>
<style lang="scss">
.error_ {
  color: red;
  line-height: 24px;
  height: 24px;
  &.hide_ {
    visibility: hidden;
  }
  &.show_ {
    visibility: show;
  }
}
.update_pwd_ {
  height: 100%;
  overflow: hidden;
  background-size: 100% 100%;
  background-position: top left;
  display: flex;
  justify-content: center;
  background-color: #fff;
  padding-top: 95px;
  // padding-top: 60px;
  border-radius: 10px;
  .left_wrap_ {
    display: inline-block;
    vertical-align: middle;
    color: #fff;
    width: 373px;
    margin-right: 143px;
    .list_ {
      li {
        &::before {
          content: "";
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin-right: 8px;
          background: #fff;
          vertical-align: middle;
        }
      }
    }
    .line_ {
      width: 36px;
      height: 3px;
      background: rgba(255, 255, 255, 1);
    }
    .title_ {
      font-size: 26px;
      margin: 28px 0;
    }
    .copyright_ {
      margin: 29px 0 19px;
    }
    .fs9_ {
      font-size: 9px;
    }
  }
}
.container_ {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 740px;
  height: 480px;
  box-sizing: border-box;
  background-size: 100% 100%;
  > p {
    width: 800px;
    text-align: center;
    margin: 0 auto;
  }
  * {
    box-sizing: border-box;
  }
  .login_left_ {
    position: absolute;
    top: 50%;
    left: 85px;
    width: 15px;
    color: #fff;
    line-height: 22px;
    font-size: 18px;
    transform: translateY(-50%);
  }
  .login_right_ {
    padding: 12px 124px 0 124px;
    background-color: #fff;
    margin: 0 auto;
    width: 800px;
    height: 420px;
    > div {
      display: flex;
      justify-content: center;
    }
    > div > span {
      width: 70px;
      white-space: nowrap;
      display: inline-block;
      padding-top: 15px;
      text-align: right;
    }
    &.long > div > span {
      width: 120px;
    }
    .btn_ {
      display: flex;
      justify-content: space-between;
    }
    .login_type_ {
      text-align: right;
      margin-right: 30px;
      margin-top: 30px;
      font-size: 14px;
      color: #2c5acc;
    }
    .type_ {
      width: 300px;
      transform: translate(25%, 10%);
      .tit_ {
        font-size: 18px;
        color: #394155;
      }
      .img_ {
        width: 16px;
        height: 16px;
      }
      .forget_ {
        margin-top: -10px;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        .forget_pwd {
          color: #2c5acc;
        }
      }
      .form_ {
        background-color: #fff;
      }
    }
    .mobile_type_ {
      transform: translateY(25%);
    }
    .bottom_logo_ {
      position: absolute;
      left: 35%;
      width: 101px;
      height: 32px;
      img {
        margin-top: 30px;
        width: 100%;
        height: 100%;
      }
    }
  }
  .login_title_ {
    margin-bottom: 29px;
    height: 27px;
    cursor: pointer;

    li {
      display: inline-block;
      color: #999999;
      font-size: 12px;
      transition: all 0.3s ease-in;
      margin-right: 29px;
      &.active_ {
        font-size: 18px;
        color: #333333;
        font-weight: 600;
      }
    }
  }
  .veri_code_ {
    width: 70px;
    height: 31px;
    background: rgba(239, 242, 255, 1);
    position: absolute;
    top: 50%;
    z-index: 2;
    transform: translateY(-50%);
    line-height: 0;
    right: 12px;
  }
  .steps_wrap_ {
    font-size: 9px;
    color: #666666;
    text-align: center;
    margin: 26px 0 42px;

    li {
      display: inline-block;
      vertical-align: middle;
    }
    .desc_01_ {
      width: 96px;
    }
    .desc_02_ {
      width: 66px;
    }
    .step_ {
      display: block;
      width: 16px;
      height: 16px;
      margin: 0 auto;
      border-radius: 50%;
      line-height: 16px;
      background: #23e2b7;
      color: #fff;
      text-align: center;
      margin-bottom: 7px;
    }
    .arrow_ {
      display: inline-block;
      vertical-align: middle;
      width: 40px;
      height: 21px;
      background: url("../assets/arrow.png") no-repeat;
      background-size: 100% auto;
      margin: 0 28px 0 23px;
    }
  }
}
.login_form_ {
  background-color: #fff;
}
.login_form_ .login-form-button {
  width: 100%;
  margin: 0 auto;
  background: linear-gradient(90deg, rgba(35, 226, 183, 1) 100%);
  border-radius: 3px;
  border: none;
  &:hover {
    background: linear-gradient(90deg, rgba(35, 226, 183, 0.6) 100%);
  }
  &:focus {
    background: linear-gradient(90deg, rgba(35, 226, 183, 1) 100%);
  }
}
.flex_btnl {
  display: flex;
  justify-content: center;
  .flex_ {
    width: 316px;
    margin-left: 80px;
    display: flex;
    justify-content: space-between;
  }
  &.long {
    .flex_ {
      margin-left: 120px;
    }
  }
}
</style>
